import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Quote API
export const submitQuote = async (quoteData) => {
  const response = await axios.post(`${API}/quote`, quoteData);
  return response.data;
};

// Advanced Quote Tool API (public)
export const submitAdvancedQuote = async (data) => {
  const response = await axios.post(`${API}/advanced-quote`, data);
  return response.data;
};

// Contact API
export const submitContact = async (contactData) => {
  const response = await axios.post(`${API}/contact`, contactData);
  return response.data;
};

// Newsletter Subscribe API
export const submitSubscribe = async (subData) => {
  const response = await axios.post(`${API}/subscribe`, subData);
  return response.data;
};

// Agent Career Interest API (interest/contact form - not account registration)
export const submitAgentInterest = async (interestData) => {
  const response = await axios.post(`${API}/agent-interest`, interestData);
  return response.data;
};

// Agent Application API
export const submitAgentApplication = async (applicationData) => {
  const response = await axios.post(`${API}/agent-application`, applicationData);
  return response.data;
};

// Agent Authentication API
export const registerAgent = async (agentData) => {
  const response = await axios.post(`${API}/agent/register`, agentData);
  return response.data;
};

export const loginAgent = async (credentials) => {
  const response = await axios.post(`${API}/agent/login`, credentials);
  return response.data;
};

export const forgotPassword = async (email) => {
  const response = await axios.post(`${API}/auth/forgot-password`, { email });
  return response.data;
};

export const resetPassword = async (token, password) => {
  const response = await axios.post(`${API}/auth/reset-password`, { token, password });
  return response.data;
};

export const getCurrentAgent = async (token) => {
  const response = await axios.get(`${API}/agent/me`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  return response.data;
};

// Weekly Activity API (Enhanced)
export const getCurrentWeekActivity = async (token) => {
  const response = await axios.get(`${API}/agent/activity/current-week`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.data;
};

export const getWeekActivity = async (weekStart, token) => {
  const response = await axios.get(`${API}/agent/activity/week/${weekStart}`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.data;
};

export const autosaveActivity = async (activityData, token) => {
  const response = await axios.put(`${API}/agent/activity/autosave`, activityData, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.data;
};

export const submitActivityReport = async (activityData, token) => {
  const response = await axios.post(`${API}/agent/activity/submit`, activityData, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.data;
};

export const unlockActivity = async (weekStart, token) => {
  const response = await axios.post(`${API}/agent/activity/unlock?week_start=${weekStart}`, {}, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.data;
};

// Weekly Goals API
export const getWeekGoals = async (weekStart, token) => {
  const response = await axios.get(`${API}/agent/goals/week/${weekStart}`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.data;
};

export const saveGoals = async (goalsData, token) => {
  const response = await axios.post(`${API}/agent/goals`, goalsData, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.data;
};

export const getGoalsVsActual = async (weekStart, token) => {
  const response = await axios.get(`${API}/agent/goals-vs-actual/${weekStart}`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.data;
};

// Unlock Request API
export const requestGoalsUnlock = async (weekStartDate, reason, token) => {
  const response = await axios.post(`${API}/agent/goals/request-unlock`, { weekStartDate, reason }, authHeader(token));
  return response.data;
};

export const getUnlockRequests = async (token) => {
  const response = await axios.get(`${API}/admin/unlock-requests`, authHeader(token));
  return response.data;
};

export const approveUnlockRequest = async (requestId, token) => {
  const response = await axios.post(`${API}/admin/unlock-requests/${requestId}/approve`, {}, authHeader(token));
  return response.data;
};

export const denyUnlockRequest = async (requestId, reason, token) => {
  const response = await axios.post(`${API}/admin/unlock-requests/${requestId}/deny`, { reason }, authHeader(token));
  return response.data;
};

// Report Email API
export const sendReportEmail = async (data, token) => {
  const response = await axios.post(`${API}/reports/send-email`, data, authHeader(token));
  return response.data;
};

export const getDefaultRecipients = async (token) => {
  const response = await axios.get(`${API}/admin/default-recipients`, authHeader(token));
  return response.data;
};

export const saveDefaultRecipients = async (recipients, token) => {
  const response = await axios.post(`${API}/admin/default-recipients`, { recipients }, authHeader(token));
  return response.data;
};

// Admin Notifications API (push notifications)
export const getUnreadNotifications = async (token) => {
  const response = await axios.get(`${API}/admin/notifications/unread`, authHeader(token));
  return response.data;
};

export const markNotificationsRead = async (ids, token) => {
  const response = await axios.post(`${API}/admin/notifications/mark-read`, { ids }, authHeader(token));
  return response.data;
};

// Agent Weekly Defaults
export const getWeeklyDefaults = async (token) => {
  const response = await axios.get(`${API}/agent/weekly-defaults`, authHeader(token));
  return response.data;
};

export const saveWeeklyDefaults = async (activityDefaults, goalsDefaults, token) => {
  const response = await axios.post(`${API}/agent/weekly-defaults`, { activityDefaults, goalsDefaults }, authHeader(token));
  return response.data;
};

// Admin Scheduled Reports Config
export const getScheduledReportsConfig = async (token) => {
  const response = await axios.get(`${API}/admin/scheduled-reports`, authHeader(token));
  return response.data;
};

export const saveScheduledReportsConfig = async (config, token) => {
  const response = await axios.post(`${API}/admin/scheduled-reports`, { config }, authHeader(token));
  return response.data;
};

// History/Reports API
export const getActivityHistory = async (token) => {
  const response = await axios.get(`${API}/agent/activity/history`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.data;
};

export const getGoalsHistory = async (token) => {
  const response = await axios.get(`${API}/agent/goals/history`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  return response.data;
};

// Lead Management API
const authHeader = (token) => ({ headers: { 'Authorization': `Bearer ${token}` } });

export const getLeads = async (token, params = {}) => {
  const query = new URLSearchParams(params).toString();
  const response = await axios.get(`${API}/leads${query ? '?' + query : ''}`, authHeader(token));
  return response.data;
};

export const createLead = async (leadData, token) => {
  const response = await axios.post(`${API}/leads`, leadData, authHeader(token));
  return response.data;
};

export const updateLead = async (leadId, updateData, token) => {
  const response = await axios.put(`${API}/leads/${leadId}`, updateData, authHeader(token));
  return response.data;
};

export const addLeadNote = async (leadId, content, token) => {
  const response = await axios.post(`${API}/leads/${leadId}/note`, { content }, authHeader(token));
  return response.data;
};

export const deleteLead = async (leadId, token) => {
  const response = await axios.delete(`${API}/leads/${leadId}`, authHeader(token));
  return response.data;
};

export const getLeadStats = async (token) => {
  const response = await axios.get(`${API}/leads/stats`, authHeader(token));
  return response.data;
};

// Admin Agent Management API
export const getPendingAgents = async (token) => {
  const response = await axios.get(`${API}/admin/pending-agents`, authHeader(token));
  return response.data;
};

export const approveAgent = async (agentId, token) => {
  const response = await axios.post(`${API}/admin/agents/${agentId}/approve`, {}, authHeader(token));
  return response.data;
};

export const rejectAgent = async (agentId, token) => {
  const response = await axios.post(`${API}/admin/agents/${agentId}/reject`, {}, authHeader(token));
  return response.data;
};

export const deactivateAgent = async (agentId, token) => {
  const response = await axios.post(`${API}/admin/agents/${agentId}/deactivate`, {}, authHeader(token));
  return response.data;
};

export const activateAgent = async (agentId, token) => {
  const response = await axios.post(`${API}/admin/agents/${agentId}/activate`, {}, authHeader(token));
  return response.data;
};

// Admin Report Settings API
export const getReportSettings = async (token) => {
  const response = await axios.get(`${API}/admin/report-settings`, authHeader(token));
  return response.data;
};

export const updateReportSettings = async (settings, token) => {
  const response = await axios.put(`${API}/admin/report-settings`, settings, authHeader(token));
  return response.data;
};

export const updateAgentTeams = async (agentId, teams, token) => {
  const response = await axios.put(`${API}/admin/agents/${agentId}/teams`, { teams }, authHeader(token));
  return response.data;
};

export const changePassword = async (currentPassword, newPassword, token) => {
  const response = await axios.put(`${API}/agent/change-password`, { currentPassword, newPassword }, authHeader(token));
  return response.data;
};

export const updateProfile = async (profileData, token) => {
  const response = await axios.put(`${API}/agent/profile`, profileData, authHeader(token));
  return response.data;
};

// Billing API
export const getBillingPackages = async () => {
  const response = await axios.get(`${API}/billing/packages`);
  return response.data;
};

export const createCheckout = async (packageId, originUrl, token) => {
  const response = await axios.post(`${API}/billing/checkout`, { packageId, originUrl }, authHeader(token));
  return response.data;
};

export const getPaymentStatus = async (sessionId, token) => {
  const response = await axios.get(`${API}/billing/status/${sessionId}`, authHeader(token));
  return response.data;
};

export const getMyPurchases = async (token) => {
  const response = await axios.get(`${API}/billing/my-purchases`, authHeader(token));
  return response.data;
};

// Training Content API
export const getTrainingContent = async (token) => {
  const response = await axios.get(`${API}/training/content`, authHeader(token));
  return response.data;
};

export const getTrainingItem = async (contentId, token) => {
  const response = await axios.get(`${API}/training/content/${contentId}`, authHeader(token));
  return response.data;
};

// Training Progress API
export const updateTrainingProgress = async (contentId, status, token) => {
  const response = await axios.post(`${API}/training/progress/${contentId}`, { status }, authHeader(token));
  return response.data;
};

export const getTrainingProgress = async (token) => {
  const response = await axios.get(`${API}/training/progress`, authHeader(token));
  return response.data;
};

// Admin API
export const getAdminMetrics = async (token) => {
  const response = await axios.get(`${API}/admin/metrics`, authHeader(token));
  return response.data;
};

export const getAuditLog = async (token, limit = 100) => {
  const response = await axios.get(`${API}/admin/audit-log?limit=${limit}`, authHeader(token));
  return response.data;
};

export const getTeams = async (token) => {
  const response = await axios.get(`${API}/admin/teams`, authHeader(token));
  return response.data;
};

export const createTeam = async (teamData, token) => {
  const response = await axios.post(`${API}/admin/teams`, teamData, authHeader(token));
  return response.data;
};

export const deleteTeam = async (teamName, token) => {
  const response = await axios.delete(`${API}/admin/teams/${teamName}`, authHeader(token));
  return response.data;
};

export const updateAgentRole = async (agentId, role, token) => {  const response = await axios.put(`${API}/admin/agents/${agentId}/role`, { role }, authHeader(token));
  return response.data;
};

export const updateAgentProfile = async (agentId, profile, token) => {
  const response = await axios.put(`${API}/admin/agents/${agentId}/profile`, profile, authHeader(token));
  return response.data;
};

export const adminResetPassword = async (agentId, newPassword, token) => {
  const response = await axios.put(`${API}/admin/agents/${agentId}/reset-password`, { newPassword }, authHeader(token));
  return response.data;
};

export const deleteAgent = async (agentId, token) => {
  const response = await axios.delete(`${API}/admin/agents/${agentId}`, authHeader(token));
  return response.data;
};

export const addAgentNote = async (agentId, note, token) => {
  const response = await axios.put(`${API}/admin/agents/${agentId}/notes`, { note }, authHeader(token));
  return response.data;
};

export const getIdleAgents = async (days, token) => {
  const response = await axios.get(`${API}/admin/agents/idle?days=${days}`, authHeader(token));
  return response.data;
};

// Notification API
export const getNotificationTemplates = async (token) => {
  const response = await axios.get(`${API}/admin/notifications/templates`, authHeader(token));
  return response.data;
};

export const createNotificationTemplate = async (data, token) => {
  const response = await axios.post(`${API}/admin/notifications/templates`, data, authHeader(token));
  return response.data;
};

export const updateNotificationTemplate = async (templateId, data, token) => {
  const response = await axios.put(`${API}/admin/notifications/templates/${templateId}`, data, authHeader(token));
  return response.data;
};

export const deleteNotificationTemplate = async (templateId, token) => {
  const response = await axios.delete(`${API}/admin/notifications/templates/${templateId}`, authHeader(token));
  return response.data;
};

export const getNotificationTriggers = async (token) => {
  const response = await axios.get(`${API}/admin/notifications/triggers`, authHeader(token));
  return response.data;
};

export const updateNotificationTrigger = async (triggerId, data, token) => {
  const response = await axios.put(`${API}/admin/notifications/triggers/${triggerId}`, data, authHeader(token));
  return response.data;
};

export const sendEmailBlast = async (data, token) => {
  const response = await axios.post(`${API}/admin/notifications/send-email`, data, authHeader(token));
  return response.data;
};

export const sendSMSBlast = async (data, token) => {
  const response = await axios.post(`${API}/admin/notifications/send-sms`, data, authHeader(token));
  return response.data;
};

export const getNotificationHistory = async (token) => {
  const response = await axios.get(`${API}/admin/notifications/history`, authHeader(token));
  return response.data;
};

export const sendDailyReport = async (data, token) => {
  const response = await axios.post(`${API}/reports/send-daily`, data, authHeader(token));
  return response.data;
};

export const getDailyActivity = async (date, token) => {
  const response = await axios.get(`${API}/agent/daily-activity?date=${date}`, authHeader(token));
  return response.data;
};

export const saveDailyActivity = async (data, token) => {
  const response = await axios.post(`${API}/agent/daily-activity`, data, authHeader(token));
  return response.data;
};

